import { render, staticRenderFns } from "./School.vue?vue&type=template&id=c9454174&scoped=true&"
import script from "./School.vue?vue&type=script&lang=js&"
export * from "./School.vue?vue&type=script&lang=js&"
import style0 from "./School.vue?vue&type=style&index=0&id=c9454174&lang=less&scoped=true&"
import style1 from "./School.vue?vue&type=style&index=1&id=c9454174&lang=less&scoped=true&"
import style2 from "./School.vue?vue&type=style&index=2&id=c9454174&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9454174",
  null
  
)

export default component.exports